import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { Moon, ClockCounterClockwise, ChartBar, Sparkle, Sliders, ChatCircleText, Question, Gear, List, X } from 'phosphor-react';
import packageJson from '../../package.json';
import './MainLayout.css';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  return (
    <div className="main-layout">
      {/* Hamburger button */}
      <button className="hamburger-btn" onClick={toggleMenu} aria-label="Menu">
        <List size={24} weight="regular" />
      </button>

      {/* Menu drawer and backdrop */}
      {isMenuOpen && (
        <>
          <div className="menu-backdrop" onClick={closeMenu} />
          <div className="menu-drawer">
            <div className="menu-header">
              <h3>Menu</h3>
              <button className="menu-close-btn" onClick={closeMenu} aria-label="Close menu">
                <X size={24} weight="regular" />
              </button>
            </div>
            <nav className="menu-nav">
              <Link
                to="/track"
                className={`menu-item ${location.pathname === '/track' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <Moon size={20} weight="light" />
                </span>
                Track
              </Link>
              <Link
                to="/history"
                className={`menu-item ${location.pathname === '/history' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <ClockCounterClockwise size={20} weight="light" />
                </span>
                History
              </Link>
              <Link
                to="/statistics"
                className={`menu-item ${location.pathname === '/statistics' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <ChartBar size={20} weight="light" />
                </span>
                Statistics
              </Link>
              <Link
                to="/predictions"
                className={`menu-item ${location.pathname === '/predictions' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <Sparkle size={20} weight="light" />
                </span>
                Predictions
              </Link>
              <Link
                to="/preferences"
                className={`menu-item ${location.pathname === '/preferences' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <Sliders size={20} weight="light" />
                </span>
                Preferences
              </Link>
              <Link
                to="/feedback"
                className={`menu-item ${location.pathname === '/feedback' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <ChatCircleText size={20} weight="light" />
                </span>
                Give Feedback
              </Link>
              <Link
                to="/support"
                className={`menu-item ${location.pathname === '/support' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <Question size={20} weight="light" />
                </span>
                Support
              </Link>
              <Link
                to="/settings"
                className={`menu-item ${location.pathname === '/settings' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="menu-icon">
                  <Gear size={20} weight="light" />
                </span>
                Settings
              </Link>
            </nav>
            <div className="menu-version">
              v{packageJson.version}
            </div>
          </div>
        </>
      )}

      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;